import { useState, useEffect, useCallback } from "react";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../hooks";
import { ReviTherapyApi } from "../../api/revi/reviTherapyApi";
import { NewReviTherapyApi } from "../../api/revi/NewReviTherapyApi"; // Para detalle profundo

const listApi = new ReviTherapyApi();
const detailApi = new NewReviTherapyApi();

export function useInstitutionTherapies() {
  // Los avisos de este hook los ve la institucion: son interfaz.
  const { t } = useTranslation("misc");
  const { user, accessToken } = useAuth();

  const [therapies, setTherapies] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, totalPages: 1 });
  const [loading, setLoading] = useState(true);

  // Estados para Modal de Detalle
  const [selectedTherapy, setSelectedTherapy] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);

  // Obtener ID de institución
  const getInstitutionId = useCallback(() => {
    const userData = user?.user || user;
    if (userData?.institutions?.length > 0) {
      return typeof userData.institutions[0] === "object"
        ? userData.institutions[0]._id
        : userData.institutions[0];
    }
    // Fallback para admin revi directo
    if (userData.role === "revi" || userData.role === "institution")
      return userData._id;
    return null;
  }, [user]);

  const institutionId = getInstitutionId();

  const loadTherapies = useCallback(
    async (page = 1, search = "") => {
      if (!institutionId || !accessToken) return;

      try {
        setLoading(true);
        const data = await listApi.getByInstitution(
          accessToken,
          institutionId,
          { page, limit: 12, search },
        );

        setTherapies(data.therapies || []);
        setPagination(data.pagination);
      } catch (error) {
        console.error(error);
        message.error(t("therapies.loadError"));
      } finally {
        setLoading(false);
      }
    },
    // `t` solo cambia al cambiar de idioma; su identidad es estable el resto
    // del tiempo, asi que no provoca recargas de mas.
    [accessToken, institutionId, t],
  );

  useEffect(() => {
    loadTherapies();
  }, [loadTherapies]);

  // Handler para ver detalle
  const handleViewDetail = async (therapySummary) => {
    setIsModalOpen(true);
    setModalLoading(true);
    try {
      // Necesitamos cargar el detalle completo (con escenas) porque el listado es ligero
      const fullData = await detailApi.getTherapyById(
        accessToken,
        therapySummary._id,
      );
      setSelectedTherapy(fullData);
    } catch (error) {
      console.error(error);
      message.error(t("therapies.detailError"));
      setIsModalOpen(false);
    } finally {
      setModalLoading(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedTherapy(null);
  };

  return {
    therapies,
    pagination,
    loading,
    loadTherapies,
    // Detalle
    selectedTherapy,
    isModalOpen,
    modalLoading,
    handleViewDetail,
    closeModal,
  };
}
